/**
 * Returns whether notes changed, so callers can clear the tile height and
 * let React Flow re-measure the tile's new content.
 */
export function didTileNotesChange(
  currentNotes: unknown,
  newNotes: string
): boolean {
  const prevNotes = typeof currentNotes === 'string' ? currentNotes : '';
  return newNotes !== prevNotes;
}
